<template>
  <container-wrapper v-slot="slotProps" :element-key="elementKey" :element-data="elementData"
    display-name="Scholarly articles" icon-name="scholarly">

    <div v-for="(article, index) in elementData.scholarlyarticle" class="accordion-item" :key="slotProps.accordionKey + index">
      <highlight-result :element-data="article" :class="getMarkupClasses(article)">

        <div class="accordion-header markup-container accordion-item-result"
          :id="'heading' + slotProps.accordionKey + index">
          <div>
            <span class="ellipsis card-title" v-html="article.title" />
            <markup-link :result-data="article" :result-type="article.resulttype" />
          </div>
        </div>

      </highlight-result>
    </div>

  </container-wrapper>
</template>

<script>
import ContainerWrapper from "@/components/card/ContainerWrapper";
import HighlightResult from "@/components/card/HighlightResult.vue";
import MarkupLink from "@/components/card/MarkupLink.vue";

export default {
  name: "ScholarlyArticles",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    ContainerWrapper,
    HighlightResult,
    MarkupLink,
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/_mixins.scss";

.accordion-item-result {
  overflow: hidden;
}
</style>
